export function getLabel(dict: any, key: string) {
  return key.split(".").reduce((obj, k) => obj?.[k], dict);
}
export const toBoolean = (value: unknown, defaultValue = true): boolean => {
  if (typeof value === "boolean") return value;

  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (v === "true" || v === "1" || v === "yes") return true;
    if (v === "false" || v === "0" || v === "no") return false;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  return defaultValue;
};
